"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIngredient = exports.getAmountAndUnitTouching = exports.getAmountAndUnit = exports.getAmount = exports.cleanText = exports.getUnit = void 0;
const units_1 = require("../../units");
const replaceAll_1 = require("../replaceAll");
exports.getUnit = (tokens) => {
    const [unit = ""] = tokens;
    const lowerUnit = unit.toLowerCase();
    const unitWithoutLastCharacter = lowerUnit.slice(0, unit.length - 1);
    if (lowerUnit === "fl" && tokens[1] === "oz") {
        return {
            unit: "fl oz",
            newTokens: tokens.slice(2, tokens.length),
        };
    }
    if (unit[0] === "-") {
        const maybeUnit = unit.slice(1, unit.length).toLowerCase();
        if (units_1.unitMap[maybeUnit]) {
            return {
                unit: maybeUnit,
                newTokens: tokens.slice(1, tokens.length),
            };
        }
        else {
            return {
                unit: "",
                newTokens: tokens.slice(1, tokens.length),
            };
        }
    }
    else if (unit.endsWith(".") && units_1.unitMap[unitWithoutLastCharacter]) {
        return {
            unit: unitWithoutLastCharacter,
            newTokens: tokens.slice(1, tokens.length),
        };
    }
    else if (unit === "" || !units_1.unitMap[lowerUnit]) {
        return {
            unit: "",
            newTokens: tokens,
        };
    }
    return {
        unit: unit.toLowerCase(),
        newTokens: tokens.slice(1, tokens.length),
    };
};
const amountRegex = /^([.]?\d[^\s]*(?: (?:- |– |to )?[-.]*\d[^\s]*)*)(.+)?/;
const ounceRegex = /(^\d[\d|\.]*)-((?:ounce|oz).+)/;
const amountInFrontOfOunceRegex = /^([\d\s.\/]+) ([\d|.]+- ?(?:ounce|oz).+)/;
const andRegex = /^(\d+[\.|\/]?\d*) and (\d+[\.|\/]?\d*) (.+)/;
exports.cleanText = (text) => replaceAll_1.replaceAll(text, replaceAll_1.spacyFractionToText)
    .replace(/^[\s\uFEFF\xA0\u200B-\u200D•\*-]+|[\s\uFEFF\xA0\u200B-\u200D]+$/g, "")
    .replace(/(\s\s+|\t\t*)/g, " ")
    .replace("⁄", "/");
exports.getAmount = (cleanedText) => {
    let amount = "";
    let rest = cleanedText;
    const regexes = [
        ounceRegex,
        amountInFrontOfOunceRegex,
        andRegex,
        amountRegex,
    ];
    for (let i = 0; i < regexes.length; i++) {
        const match = cleanedText.match(regexes[i]);
        if (match) {
            if (i === 2) {
                amount = `${match[1]} ${match[2]}`;
                rest = match[3];
            }
            else {
                amount = match[1];
                rest = match[2];
            }
            break;
        }
    }
    return { amount: amount.trim(), rest: (rest || "").trim() };
};
exports.getAmountAndUnit = (cleanedText) => {
    const { amount, rest } = exports.getAmount(cleanedText);
    return Object.assign({ amount }, exports.getUnit(rest.split(" ")));
};
const touchingRegex = /^(\d+(?:\.\d+)?)(.+)/;
exports.getAmountAndUnitTouching = (s) => {
    const match = s.match(touchingRegex);
    if (!match) {
        return null;
    }
    const [, amount, rest] = match;
    const tokens = rest.split(" ");
    const unitNotTouching = !tokens.length || !units_1.unitMap[(tokens[0] || "").toLowerCase()];
    if (unitNotTouching) {
        return null;
    }
    return {
        amount,
        unit: tokens[0],
        newTokens: tokens.slice(1, tokens.length),
    };
};
exports.parseIngredient = (text) => {
    const cleanedText = exports.cleanText(text);
    let { amount, unit, newTokens: nameTokens } = exports.getAmountAndUnitTouching(cleanedText) || exports.getAmountAndUnit(cleanedText);
    if (amount === "1" && unit && units_1.unitPluralToSingular[unit]) {
        unit = units_1.unitPluralToSingular[unit];
    }
    const parsedIngredient = {
        name: nameTokens.join(" "),
        unit,
        amount: amount || "",
    };
    return parsedIngredient;
};
//# sourceMappingURL=index.js.map